import React, { ReactNode, createContext, useCallback, useEffect, useState } from 'react';

interface SuspendedCallback {
  run: any;
  type: string;
}

export interface SuspendStartOverCancel {
  suspended: boolean;
  setSuspended: (suspended: boolean) => void;
  suspendedCallback: SuspendedCallback | null;
  setSuspendedCallback: (callback: SuspendedCallback | null) => void;
}

interface PausedCallbackProps {
  children: ReactNode | ReactNode[];
}

export const SuspendStartOverCancelContext = createContext<SuspendStartOverCancel>(
  {} as SuspendStartOverCancel
);

export const SuspendStartOverCancelConsumer = SuspendStartOverCancelContext.Consumer;

export const SuspendStartOverCancelProvider = (props: PausedCallbackProps): any => {
  const { children } = props;

  const [suspended, setSuspended] = useState(false);
  const [suspendedCallback, setSuspendedCallback] = useState<SuspendedCallback | null>(null);

  const handleStartOver = useCallback(() => {
    suspendedCallback?.run();

    setSuspended(false);
    setSuspendedCallback(null);
  }, [setSuspended, setSuspendedCallback, suspendedCallback]);

  useEffect(() => {
    if (suspendedCallback) {
      handleStartOver();
    }
  }, [suspendedCallback, handleStartOver]);

  return (
    <SuspendStartOverCancelContext.Provider
      value={{ suspended, setSuspended, suspendedCallback, setSuspendedCallback }}
    >
      {children}
    </SuspendStartOverCancelContext.Provider>
  );
};

export default SuspendStartOverCancelProvider;
